import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector, useStore } from 'react-redux';
import { useForm } from 'react-hook-form';
import CustomizedGrid from '../../../../components/base/Grid/CustomizedGrid';
import Pagination from '../../../../components/base/Pagination/Pagination';
import { intlShape } from '../../../../components/base/IntlProviderWrapper';
import { Button, Icons } from '../../../../components/base/BootstrapComponents/BootstrapComponents';
import {
  getFilterData, getPaginationOpts, responseLogWithNotification, useUpdatePeriod,
} from '../../../../utils/utils';
import { VISITS_MODULE } from '../../../../configs/moduleNames';
import { getSystemData } from '../../../System/reducer';
import { getVisitData } from '../../../Visits/reducer';
import { loadVisitsList } from '../../../Visits/actions';
import { visitColumns, visitDetailsColumns } from '../../../Visits/components/visitsColumns';
import FilterRow from '../../../../components/base/FilterRow/FilterRow';
import FieldDTO from '../../../../components/fields/Abstract/FieldDTO';
import TextInput from '../../../../components/fields/TextInput/TextInput';
import { addGlobalPopUpWrapper } from '../../../InformationScreenWrapper/actions';
import { POPUP_LIST_NAME } from '../../../../configs';
import getDefaultSort from '../../../../utils/getDefaultSort';
import { PAGE_TYPE } from '../../../FilterTemplate/components/filter-settings';
import FilterModal from '../../../FilterTemplate/components/FilterModal';
import TimerLoader from '../../../../components/base/Loader/TimerLoader';
import TextSearchInput from '../../../../components/fields/TextInput/TextSearchInput';

function VisitBox(props) {
  const { driver_id, onClose = () => {} } = props;
  const dispatch = useDispatch();
  const {
    visitList = [],
    loadingVisitList,
    visitListMeta,
  } = useSelector(getVisitData);
  const store = useStore();
  const {
    formatMessage,
  } = intlShape;
  const rowClassFormatter = item => {
    const classes = ['clickable-table-row'];
    return classes.join(' ');
  };
  const loadData = opts => {
    const paginationOpts = getPaginationOpts(store.getState()[VISITS_MODULE].transportListMeta, opts);
    const requestData = {
      ...paginationOpts,
      filter: { driver_id, ...getValues() },
      sort,
    };
    const p1 = dispatch(loadVisitsList(requestData)).catch(responseLogWithNotification);
    return Promise.all([p1]);
  };

  const [isOpenFilter, setOpenFilter] = useState(false);
  const {
    getValues, control, watch, setValue, reset,
  } = useForm({ defaultValues: getFilterData('driver-visit-filter', {}) });
  const { updatePeriod } = useSelector(getSystemData);
  const [setPeriod] = useUpdatePeriod(loadData, updatePeriod);
  useEffect(() => setPeriod(updatePeriod), [updatePeriod]);

  useEffect(() => {
    const subscription = watch(values => {
      localStorage.setItem('driver-visit-filter', JSON.stringify(values));
      loadData({ page: 1 });
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  const moreFormatter = (_, item) => (
    <Icons customIcon icon="more-vert" className="more-vert" />
  );

  const [sort, setSort] = useState(getDefaultSort(visitColumns));

  const changeSort = fieldName => {
    if (sort && (sort === fieldName || sort === `-${fieldName}`)) {
      if (sort === `-${fieldName}`) {
        setSort(fieldName);
      } else if (sort === fieldName) {
        setSort('');
      }
    } else {
      setSort(`-${fieldName}`);
    }
  };

  useEffect(() => { loadData(); }, [sort]);

  return (
    <div className="dlc-body flex-column">
      <TimerLoader loading={loadingVisitList} />
      <div className="dlc-title">
        <Icons width={24} height={24} customIcon icon="arrow-return" onClick={onClose} />
        <div className="f3">{formatMessage({ id: 'driver.card.menu.history' })}</div>
        <FilterRow>
          <FieldDTO
            control={control}
            component={TextSearchInput}
            dtoObject={{
              name: 'search',
              type: String,
              labelKey: 'search',
            }}
          />
          <Button
            variant="second"
            className=""
            onClick={() => {
              setOpenFilter(true);
            }}
          >
            <Icons customIcon className="file-download" width={24} height={24} icon="filter" />
          </Button>
          {isOpenFilter
            ? (
              <FilterModal
                control={control}
                onClose={() => setOpenFilter(false)}
                getValues={getValues}
                reset={reset}
                defaultValues={{}}
                page={PAGE_TYPE.VISITS}
              />
            )
            : null}
        </FilterRow>
      </div>
      <div className="grid-wrapper frame">
        <div className="custom-scroll-theme sticky-table-wrapper custom">
          <CustomizedGrid
            data={visitList}
            columns={[...visitColumns, ...visitDetailsColumns]}
            onDoubleClickByRow={item => {
              dispatch((addGlobalPopUpWrapper({ window: POPUP_LIST_NAME.VISIT_DETAIL, id: item.id })));
            }}
            additionalColumns={[]}
            settingsFormatter={moreFormatter}
            rowClassFormatter={rowClassFormatter}
            changeSort={changeSort}
            sort={sort}
          />
        </div>
        <Pagination meta={visitListMeta} list={visitList} handleChangeMeta={loadData} />
      </div>
    </div>
  );
}

export default VisitBox;
